module.exports = __webpack_public_path__ + "static/media/plus.ab21819f.svg";